module.exports = __webpack_public_path__ + "static/integration_bg_1024x611-c6d44f2439d49a6050dab460e511dbe2.jpg";